import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useGAPageView = (name: string, data: any = {}): void => {
  // console.log(name, data, "useGAPageView not working yet.");
  useEffect(() => {
    // gtag("event", "page_view", { page_title: name, ...data });
  }, []);
};
